import { useMemo } from 'react';
import { callDeepLink } from '@croquiscom/web2app';

import { useCatalogProductIdParams, useGetPdpIntegratedData, usePdpConfig } from '@domains/pdp-common';

import { useShippingUBL } from '../log/useShippingUBL';

const ALPHA_BASE_URL = 'https://zigzag-kr-alpha.zendesk.com/hc/ko/articles';
const BASE_URL = 'https://zigzagkr.zendesk.com/hc/ko/articles';
const prod_list = ['store.zigzag.kr', 'store.beta.zigzag.kr', 'zigzag.kr', 'beta.zigzag.kr'];
export const useShippingInfoService = () => {
  const { isZigzagApp } = usePdpConfig();
  const { shippingNoticeBannerClickUBL } = useShippingUBL();

  const params = useCatalogProductIdParams();
  const { extra_notice_banner } = useGetPdpIntegratedData(params);

  const notice_id = extra_notice_banner?.notice_id;
  const notice = extra_notice_banner?.title ?? '';

  const notice_link = useMemo(() => {
    try {
      const hostname = window.location.hostname;
      const is_prod = !!prod_list.find((o) => o === hostname);
      const URL = is_prod ? BASE_URL : ALPHA_BASE_URL;
      return `${URL}/${notice_id}`;
    } catch (e) {
      return '';
    }
  }, [notice_id]);

  const handleClick = () => {
    if (!notice_id) {
      return;
    }

    shippingNoticeBannerClickUBL();

    if (isZigzagApp) {
      callDeepLink('/simple_browser')({
        url: encodeURIComponent(notice_link),
      });
      return;
    }

    window.open(notice_link);
  };

  return {
    handleClick,
    is_hide: !extra_notice_banner,
    notice,
    show_arrow_icon: !!notice_id,
  };
};
